import { render, staticRenderFns } from "./filmVersionRecord.vue?vue&type=template&id=3e51a377&scoped=true&"
import script from "./filmVersionRecord.vue?vue&type=script&lang=js&"
export * from "./filmVersionRecord.vue?vue&type=script&lang=js&"
import style0 from "./filmVersionRecord.vue?vue&type=style&index=0&id=3e51a377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51a377",
  null
  
)

export default component.exports